import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u268",
  "use": "icon-u268-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-u268\"><path d=\"M512 153.6v358.4h358.4a358.4 358.4 0 1 1-370.688-358.1952L512 153.6z m51.2-51.2a358.4 358.4 0 0 1 358.1952 346.112L921.6 460.8h-358.4V102.4z\" p-id=\"820\" fill=\"#25E3C9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol